module.exports = __webpack_public_path__ + "img/products.55ef93ea.jpg";